(() => {
  const root = document.querySelector('.main-product');
  if (!root || root.dataset.pdpLoadingMounted) return;
  root.dataset.pdpLoadingMounted = 'true';

  root.querySelectorAll('.product__media-list .product__media').forEach((frame) => {
    const image = [...frame.querySelectorAll('img')].find((item) => !item.closest('.lazy-image__preloader'));
    if (!image) return;
    let revision = 0;
    let errorUI;
    const previousBusy = frame.getAttribute('aria-busy');
    const settle = () => {
      frame.removeAttribute('data-pdp-image-pending');
      if (previousBusy === null) frame.removeAttribute('aria-busy');
      else frame.setAttribute('aria-busy', previousBusy);
    };
    const pending = () => {
      revision += 1;
      errorUI?.remove();
      frame.removeAttribute('data-pdp-image-error');
      frame.setAttribute('data-pdp-image-pending', '');
      frame.setAttribute('aria-busy', 'true');
    };
    const loaded = async () => {
      const current = revision;
      if (!image.naturalWidth) return failed();
      try { await image.decode?.(); } catch { /* Loaded pixels remain usable when decoding rejects. */ }
      if (current !== revision) return;
      if (!image.naturalWidth) return failed();
      frame.removeAttribute('data-pdp-image-error');
      errorUI?.remove();
      image.closest('.lazy-image')?.classList.add('lazyloaded');
      settle();
    };
    const failed = () => {
      revision += 1;
      settle();
      frame.setAttribute('data-pdp-image-error', '');
      errorUI?.remove();
      errorUI = document.createElement('div');
      errorUI.className = 'pdp-image-fallback';
      const label = document.createElement('span');
      label.textContent = 'Image unavailable';
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Retry image';
      retry.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        pending();
        image.loading = 'eager';
        const source = new URL(image.currentSrc || image.src, location.href);
        source.searchParams.set('_pdp_retry', String(Date.now()));
        image.removeAttribute('srcset');
        image.src = source.href;
      });
      errorUI.append(label, retry);
      frame.append(errorUI);
    };
    image.addEventListener('load', loaded);
    image.addEventListener('error', failed);
    pending();
    if (image.complete) {
      if (image.naturalWidth) loaded();
      else if (image.currentSrc || image.getAttribute('src')) failed();
    }
  });

  const drawer = document.querySelector('mto-purchase-drawer');
  const template = drawer?.querySelector('[data-mto-actions]');
  const blocks = [...root.querySelectorAll('.buy-buttons')];
  if (!template || !blocks.length) return;
  const existingHidden = new Set(document.querySelectorAll('.mto-native-control--hidden'));
  const native = new Set(root.querySelectorAll('.buy-buttons, variant-radios, variant-selects, .product-form__quantity'));
  if (root.querySelector('[data-mto-heading-rate]')) {
    root.querySelectorAll('[id^="price-"]').forEach((item) => native.add(item));
  }
  document.querySelectorAll('.sticky-cart__form').forEach((form) => native.add(form.closest('animate-sticky') || form));
  const previous = [...native].map((item) => [item, item.getAttribute('data-pdp-native-pending')]);
  const placeholders = blocks.map((block) => {
    const placeholder = template.cloneNode(true);
    [placeholder, ...placeholder.querySelectorAll('*')].forEach((item) => {
      [...item.attributes].forEach(({ name }) => {
        if (name === 'id' || name === 'name' || name === 'for' || name.startsWith('data-mto') || name.startsWith('aria-')) item.removeAttribute(name);
      });
      if ('disabled' in item) item.disabled = true;
      item.removeAttribute('href');
    });
    placeholder.hidden = false;
    placeholder.setAttribute('data-pdp-chooser-placeholder', '');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.setAttribute('inert', '');
    block.before(placeholder);
    return placeholder;
  });
  previous.forEach(([item]) => item.setAttribute('data-pdp-native-pending', ''));
  const previousBusy = root.getAttribute('aria-busy');
  root.setAttribute('aria-busy', 'true');
  let settled = false;
  const finish = (success) => {
    if (settled) return;
    settled = true;
    if (previousBusy === null) root.removeAttribute('aria-busy');
    else root.setAttribute('aria-busy', previousBusy);
    placeholders.forEach((item) => item.remove());
    previous.forEach(([item, value]) => {
      if (value === null) item.removeAttribute('data-pdp-native-pending');
      else item.setAttribute('data-pdp-native-pending', value);
    });
    if (!success) {
      root.querySelectorAll('[data-mto-actions]').forEach((item) => item.remove());
      root.querySelectorAll('.mto-native-control--hidden').forEach((item) => {
        if (!existingHidden.has(item)) item.classList.remove('mto-native-control--hidden');
      });
      native.forEach((item) => {
        if (!existingHidden.has(item)) item.classList.remove('mto-native-control--hidden');
      });
    }
    document.removeEventListener('vorug:pdp-chooser-ready', ready);
    document.removeEventListener('vorug:pdp-chooser-failed', failed);
    window.removeEventListener('error', resourceError, true);
  };
  const ready = () => finish(true);
  const failed = () => finish(false);
  const resourceError = (event) => {
    if (event.target?.tagName === 'SCRIPT' && /(?:^|\/)mto-purchase-drawer\.js(?:\?|$)/.test(event.target.src)) failed();
  };
  document.addEventListener('vorug:pdp-chooser-ready', ready);
  document.addEventListener('vorug:pdp-chooser-failed', failed);
  window.addEventListener('error', resourceError, true);
  const fallback = () => requestAnimationFrame(() => { if (!settled) failed(); });
  if (document.readyState === 'complete') fallback();
  else window.addEventListener('load', fallback, { once: true });
})();
